import React, { Component } from 'react'

import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import PageWrapper from '../../components/PageWrapper'
import BorderButton from '../../components/BorderButton'
import { Preloader } from '../../components/Chart/index'
import WhiteBox from '../../components/WhiteBox'
//import './styles.css'
import axios from 'axios'

import { getAudiencePrefix } from '../../lib/get-audience-prefix'
import CookieTypes from '../../components/CookieTypes'
import PartnerTypes from '../../components/PartnerTypes'
import ReactTooltip from 'react-tooltip'

import 'react-bootstrap-toggle/dist/bootstrap2-toggle.css'
import { Bootstrap2Toggle } from 'react-bootstrap-toggle'
import RevenueShareList from '../../components/RevenueShareList'
import debounce from 'lodash/debounce'
import { uniqueDmps } from '../../lib/format-dmps'
import { countries } from '../../lib/countries'
import BulkRevshareModal from '../../components/BulkRevshareModal'

import Autocomplete from '@material-ui/lab/Autocomplete'
import TextField from '@material-ui/core/TextField'
import { countryToFlag } from '../../lib/format-dmps'
import Checkbox from '@material-ui/core/Checkbox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;



class EditPartner extends Component {
    state = {

        friendlyName: "New partner name",
        //partnerType: "DATA_PROVIDER",
        //cookieTypes: "ar",
        maxAudiences: 10000,
        maxLicenses: 10000,
        maxUploadsDaily: 400,
        pricingType: 'revshare',
        partnerAlias: null,
        gdprConfirm: true,
        canEdit: true,
        canCreateChildren: false,
        region: "us",

        showBulkRevhsareModal: false,
        revshares: [],
        revshareSize: 1000,
        revshareOffset: 0,
        revshareFilter: '',
        revshareSort: 'partnerId,dmp,product',
        revshareSortOrder: 'desc',
        revshareFilter: "",

        marketerMaxCompositeSize: 1000000000,
        marketerRevshare: 10.0,
        marketerOnTopRevshare: 15.0,
        marketerCountriesSelected: [],
        marketerPartnerSelected: [],
        canEditCompositeAudiencesCpm: false, 
        partners: [],


    }

    componentDidMount() {

         // load partner lists
         axios.get('/partner?offset=0&size=10000&filter=').then(response => {
            console.log('get partner ', response.data)

            let data = response.data.body[0] || {}
            let subPartnerSettings = data.subPartnerSettings || []
    
            //subPartnerSettings = subPartnerSettings.concat([{"partnerId": "p-admin", "friendlyName": "Audiencerate"}])
            subPartnerSettings = [{"partnerId": "p-admin", "friendlyName": "Audiencerate"}].concat(subPartnerSettings)


            this.setState({
                partners: subPartnerSettings,
            }, () => {
                //

                 // also fetch marketer data if ant
        if (this.props.location.state.partner.partnerType
            && this.props.location.state.partner.partnerType.indexOf("MARKETER") !== -1) {

            this.setState({ loadingMarketer: true }, () => {
                axios.get("/market/partner?partnerId=" + this.props.location.state.partner.partnerId)
                    .then(response => {
                        console.log("marketer data ", response.data)
                        
                        // from ISO codes saved, find real countries object so we 
                        // can get the selection visible 
                        let countriesSelectedIsoCode = response.data.body.marketerSettings.marketerCountriesVisibility != "" ?
                        response.data.body.marketerSettings.marketerCountriesVisibility.split(",") : [];
                        let countriesSelectedObjs = []
                        for(let i = 0; i < countriesSelectedIsoCode.length; i++){
                            countriesSelectedObjs.push(
                                 countries.find(el => el.iso2Code === countriesSelectedIsoCode[i] )
                            )
                        }


                        let partnerSelected = response.data.body.marketerSettings.marketerPartnerVisibility != "" ?
                            response.data.body.marketerSettings.marketerPartnerVisibility.split(",") : [];
                        let partnersSelectedObjs = []
                        console.log("partnerSelected", partnerSelected)
                        console.log("partners", this.state.partners)
                        for(let i = 0; i < partnerSelected.length; i++){
                            partnersSelectedObjs.push(
                                 this.state.partners.find(el => el.partnerId === partnerSelected[i] )
                            )
                        }
                        console.log("partnersSelectedObjs", partnersSelectedObjs)






                        this.setState({
                            marketerMaxCompositeSize: parseInt(response.data.body.marketerSettings.marketerMaxCompositeSize),
                            marketerRevshare: response.data.body.marketerSettings.marketerRevshare,
                            marketerOnTopRevshare: response.data.body.marketerSettings.marketerRevshareOnTop,
                            canEditCompositeAudiencesCpm: response.data.body.marketerSettings.marketerCompositeCanEditCpm == 1,
                            marketerCountriesSelected: countriesSelectedObjs,
                            marketerPartnerSelected: partnersSelectedObjs,
                            loadingMarketer: false,
                        })
                        //alert(this.state.marketerCountriesSelected)
                    })
            })

        }







                //    
            })
        })


        console.log("patner edit ", this.props.location.state.partner)
        this.setState({
            loading: true,
            partnerId: this.props.location.state.partner.partnerId,
            friendlyName: this.props.location.state.partner.friendlyName,
            partnerType: this.props.location.state.partner.partnerType,
            cookieTypes: this.props.location.state.partner.cookieTypes,
            maxAudiences: this.props.location.state.partner.maxAudiences,
            maxLicenses: this.props.location.state.partner.maxLicenses,
            maxUploadsDaily: this.props.location.state.partner.maxUploadsDaily,
            pricingType: this.props.location.state.partner.pricingType,
            partnerAlias: this.props.location.state.partner.partnerAlias,
            gdprConfirm: this.props.location.state.partner.gdprConfirm == 1,
            canEdit: this.props.location.state.partner.canEdit == 1,
            canCreateChildren: this.props.location.state.partner.canCreateChildren == 1,
            region: this.props.location.state.partner.region,

            countries: countries
                .filter(c => c.hasOwnProperty('iso2Code'))
                .sort((a, b) => {
                    var keyA = a.name,
                        keyB = b.name
                    if (keyA < keyB) return -1
                    if (keyA > keyB) return 1
                    return 0
                }),

        }, () => {



            this.loadRevShares(this.state.partnerId)
            this.setState({ loading: false })
        })

        this.debouncedRevshareFilter = debounce(this.loadRevShares, 300)



       

    }

    loadRevShares(filter = '', offset = 0, size = 1000, reset = true) {

        // always filter for this partner id 
        filter = this.state.partnerId

        axios
            .get(
                '/revshare?size=' +
                size +
                '&offset=' +
                offset +
                '&sort=' +
                this.state.revshareSort +
                '&sortOrder=' +
                this.state.revshareSortOrder +
                '&filter=' +
                filter
            )
            .then(response => {
                console.log('revshare list', response, response.data.body)

                let revshares = []
                if (reset) {
                    revshares = response.data.body
                } else {
                    revshares = this.state.revshares
                    revshares = revshares.concat(response.data.body)
                }
                revshares.forEach(r => {
                    r.minPrice = parseFloat(r.minPrice / 1000000).toFixed(2)
                })
                this.setState({ revshares: revshares, loading: false }, () => {
                    this.loadDmpList()
                })
            })
    }
    onRevenueShareChange(event, row, index, id = null) {
        console.log('onRevenueShareChange', event, id)
        if (id != null) {
            let value = event
            event = { target: { id: id, type: 'text', value: value } }
        }
        console.log('onRevenueShareChange 2', event, event.target, event.target.type)
        let revshares = this.state.revshares
        const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value

        if (event.target.id === 'minPrice' && !value.match(/^[0-9.]*$/)) {
            console.log('invalid number')
            return
        }

        //console.log('onRevenueShareChange', event, row, index)
        revshares[index][event.target.id] = value
        if ('dmp' === event.target.id) {
            this.loadDmpDetails(value)
        }
        this.setState({ revshares: revshares })
    }

    onRevenueShareAdd() {
        console.log('onRevenueShareAdd')
        let revshares = this.state.revshares
        let newObj = {
            new: true,
            partnerId: this.state.partnerId,
            revShare: 10.0,
            dmp: this.state.dmpList[0].dmp,
            product: this.state.dmpProducts && this.state.dmpProducts.length && this.state.dmpProducts[0].product,
            currency: 'USD',
            minPrice: 0.1
        }
        revshares.push(newObj)
        // dynamic update field on list: override object
        this.setState({ revshares: revshares })
    }


    // bulk create some revshare
    onRevenueShareBulkCreate() {
        console.log('onRevenueShareBulkCreate')
        // show modal to bulk create 
        this.setState({ showBulkRevhsareModal: true, }, () => {

        });
    }
    onRevenueShareSave(row, index) {
        console.log('onRevenueShareSave')
        // new | edit
        let method = 'POST'
        if (!row.new) method = 'PATCH'

        this.setState({ loading: true }, () => {
            axios
                .request({
                    url: '/revshare',
                    method: method,
                    data: {
                        dmp: row.dmp,
                        partnerId: row.partnerId,
                        product: row.product,
                        revShare: row.revShare,
                        minPrice: parseFloat(row.minPrice) * 1000000,
                        currency: row.currency
                    }
                })
                .then(response => {
                    this.loadRevShares()
                })
                .catch(error => {
                    this.setState({ loading: false })
                    console.log(error)
                })
        })
    }

    onRevenueShareRemove(row, index) {
        console.log('onRevenueShareRemove')
        // if the row is not already saved on BE don't make the api call to delete but cancel only on the FE
        if (row.new) {
            let data = this.state.data
            data.revshares.splice(index, 1)
            this.setState(data)
            return
        }
        this.setState({ loading: true }, () => {
            axios
                .request({
                    url: '/revshare',
                    method: 'DELETE',
                    data: {
                        dmp: row.dmp,
                        partnerId: row.partnerId,
                        product: row.product,
                        revShare: row.revShare,
                        currency: row.currency
                    }
                })
                .then(response => {
                    console.log('onRevenueShareRemove response', response)
                    /*let data = this.state.data
                    data.revshares.splice(index, 1)
                    this.setState({ data: data, loading: false })
                    */
                    this.loadRevShares()
                })
        })
    }
    onRevenueShareLoadMore() {
        let offset = this.state.revshareOffset + this.state.revshareSize
        this.setState({ revshareOffset: offset }, () => {
            this.debouncedRevshareFilter(this.state.revshareFilter, this.state.revshareOffset, this.state.revshareSize, false)
        })
    }
    onRevshareFilterChange(target) {
        let offset = 0
        this.setState({ revshareOffset: offset, revshareFilter: target.value }, () => {
            this.debouncedRevshareFilter(target.value, this.state.revshareOffset, this.state.revshareSize, true)
        })
    }

    loadDmpList() {
        axios.get('/dmpDetails').then(response => {
            console.log('dmp list', response, response.data.body)
            this.setState({ dmpList: uniqueDmps(response.data.body, false), dmpProducts: [] }, () => {
                this.loadDmpDetails(this.state.dmpList[0].dmp)
            })
        })
    }
    loadDmpDetails(dmpName) {
        axios.get('/dmpDetails?dmp=' + dmpName).then(response => {
            console.log('dmp product list', response, response.data.body)
            this.setState({ dmpProducts: response.data.body }, () => {
                // update the new revshare with the first product loaded
                let revshares = this.state.revshares
                let index = revshares.findIndex(it => it.new)
                if (index != -1) {
                    console.log('update new revshare with index ', index)
                    revshares[index].product = this.state.dmpProducts[0].product
                    console.log('update new revshare with data:  ', revshares[index])
                    this.setState({ revshares: revshares })
                }
            })
        })
    }



    onSubPartnersSave() {
        console.log('onSubPartnersSave ', this, this.state)

        //console.log("marketerCountriesSelected", this.state.marketerCountriesSelected)
        //return



        // new | edit
        let method = 'PATCH'
        let data = {
            partnerId: this.state.partnerId,
            friendlyName: this.state.friendlyName,
            canCreateChildren: this.state.canCreateChildren ? 1 : 0,
            canEdit: this.state.canEdit ? 1 : 0,
            gdprConfirm: this.state.gdprConfirm ? 1 : 0,
            region: this.state.region,
            partnerType: this.state.partnerType,
            cookieTypes: this.state.cookieTypes,
            partnerAlias: this.state.partnerAlias,
            maxAudiences: this.state.maxAudiences,
            maxLicenses: this.state.maxLicenses,
            maxUploadsDaily: this.state.maxUploadsDaily,
            pricingType: this.state.pricingType,

            marketerMaxCompositeSize: this.state.marketerMaxCompositeSize,
            marketerRevshare: this.state.marketerRevshare,
            marketerRevshareOnTop: this.state.marketerOnTopRevshare,
            marketerCountriesVisibility: this.state.marketerCountriesSelected.map(el => el.iso2Code).join(","),
            marketerPartnerSelected : this.state.marketerPartnerSelected.map(el => el.partnerId).join(","),
            canEditCompositeAudiencesCpm: this.state.canEditCompositeAudiencesCpm ? 1 : 0,

        }


        this.setState({ loading: true }, () => {
            axios
                .request({
                    url: '/partner',
                    method: method,
                    data: data
                })
                .then(response => {
                    console.log('save response', response)
                    this.setState({ loading: false })
                    window.location.href = '/settings'
                })
        })
    }



    render() {
        const { name } = this.state
        const { segments, loading, hasMore } = this.props
        return (
            <PageWrapper>
                <div className="container-fluid">
                    <div className="row justify-content-center">
                        <div className="col-10">
                            <WhiteBox>
                                <div
                                    style={{
                                        position: 'relative',
                                        paddingRight: 100
                                    }}>
                                    <div className="row">
                                        <div className="col-3">
                                            <img src="/img/audience/illy-segment-based-audience.svg" alt="" />
                                        </div>
                                        <div className="col-9">
                                            <h3 style={{ marginTop: 26 }}>EDIT PARTNER {this.state.partnerId}</h3>

                                            <div className="row">
                                                <div className="col">
                                                    <p style={{ marginTop: 30 }}>Friendly name</p>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={this.state.friendlyName}
                                                        onChange={({ target }) => this.setState({ friendlyName: target.value })}
                                                    />
                                                </div>
                                                <div className="col">
                                                    <p style={{ marginTop: 30 }}>Region</p>
                                                    <select value={this.state.region} className="form-control" id="region" onChange={event => this.setState({ region: event.target.value })}>
                                                        <option key="us" value="us">
                                                            United States
                                                </option>
                                                        <option key="eu" value="eu">
                                                            Europe
                                                </option>
                                                    </select>

                                                </div>
                                            </div>



                                            <p style={{ marginTop: 30 }}>Partner Type</p>
                                            {!this.state.loading && (
                                                <PartnerTypes
                                                    partnerTypes={this.state.partnerType ? this.state.partnerType.split(",") : []}
                                                    onPartnerTypeChange={(partnerTypes) => {
                                                        console.log('partner types change update', partnerTypes)
                                                        this.setState({ partnerType: partnerTypes.join(",") })
                                                    }} />
                                            )}
                                            <p style={{ marginTop: 30 }}>Cookie Types</p>
                                            {!this.state.loading && (
                                                <CookieTypes
                                                    cookieTypes={this.state.cookieTypes ? this.state.cookieTypes.split(",") : []}
                                                    onCookieTypeChange={(cookieTypes) => {
                                                        console.log('cookie types change update', cookieTypes)
                                                        this.setState({ cookieTypes: cookieTypes.join(",") })
                                                    }} />
                                            )}

                                            <br />

                                            {this.state.partnerType && this.state.partnerType.indexOf("MARKETER") !== -1 && (
                                                <div style={{
                                                    'border': '1px solid rgb(221, 221, 221)',
                                                    'padding': '20px'
                                                }}>
                                                    <h3>Marketer Settings</h3>

                                                    <div className="row">
                                                        <div className="col">
                                                            <p style={{ marginTop: 30 }}>Revenue share %</p>
                                                            <input
                                                                type="number"
                                                                min="0.0"
                                                                className="form-control"
                                                                value={this.state.marketerRevshare}
                                                                onChange={({ target }) => this.setState({ marketerRevshare: target.value })}
                                                            />
                                                            <font style={{ fontSize: '13px', color: '#888' }}>% applied for a marketer revenue share %.</font>

                                                        </div>
                                                        <div className="col">
                                                            <p style={{ marginTop: 30 }}>On top revenue share %</p>
                                                            <input
                                                                type="number"
                                                                min="0.0"
                                                                className="form-control"
                                                                value={this.state.marketerOnTopRevshare}
                                                                onChange={({ target }) => this.setState({ marketerOnTopRevshare: target.value })}
                                                            />
                                                            <font style={{ fontSize: '13px', color: '#888' }}>Marketer on top premium revenue share %.</font>

                                                        </div>
                                                        <div className="col">
                                                            <p style={{ marginTop: 30 }}>Max Composite Size</p>
                                                            <input
                                                                type="number"
                                                                min="0.0"
                                                                className="form-control"
                                                                value={this.state.marketerMaxCompositeSize}
                                                                onChange={({ target }) => this.setState({ marketerMaxCompositeSize: target.value })}
                                                            />
                                                            <font style={{ fontSize: '13px', color: '#888' }}>Marketer max composite size permitted.</font>

                                                        </div>
                                                        <div className="col">

                                                            <p style={{ marginTop: 30 }}>Can Edit CPM on Composite Audiences</p>
                                                            <p style={{ 'margin': 0 }}>
                                                                <Bootstrap2Toggle
                                                                    onClick={value => {
                                                                        this.setState({ canEditCompositeAudiencesCpm: value })
                                                                    }}
                                                                    on={<span>ON</span>}
                                                                    off={<span>OFF</span>}
                                                                    size="xs"
                                                                    offstyle="secondary"
                                                                    active={this.state.canEditCompositeAudiencesCpm}
                                                                />
                                                            </p>
                                                            <font style={{ fontSize: '13px', color: '#888' }}>Toggle if the Partner has editing cababilities when creating a new Composite and related CMP.</font>

                                                            </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col">
                                                            <p style={{ marginTop: 30 }}>Countries Visibility</p>
                                                            {!this.state.loadingMarketer && this.state.countries && this.state.countries.length > 0 
                                                                && this.state.marketerCountriesSelected && (
                                                                <Autocomplete
                                                                    id="country-select"
                                                                    options={this.state.countries}
                                                                    autoHighlight
                                                                    multiple
                                                                    limitTags={1}
                                                                    disableCloseOnSelect
                                                                    defaultValue={this.state.marketerCountriesSelected}
                                                                    getOptionLabel={option => option.name || option}
                                                                    onChange={(event, newValue) => {
                                                                        if (newValue) {
                                                                            console.log('country change ', newValue)
                                                                            //let marketerCountriesSelected = newValue.map(el => el.iso2Code)
                                                                            let marketerCountriesSelected = newValue
                                                                            this.setState({ marketerCountriesSelected: marketerCountriesSelected })
                                                                        }
                                                                    }}
                                                                    renderOption={(option, { selected }) => (
                                                                        <React.Fragment>
                                                                            <Checkbox
                                                                                color="primary"
                                                                                icon={icon}
                                                                                checkedIcon={checkedIcon}
                                                                                style={{ marginRight: 8 }}
                                                                                checked={selected}
                                                                            />
                                                                            <span>{countryToFlag(option.iso2Code)}</span>&#160;{option.name}
                                                                        </React.Fragment>
                                                                    )}
                                                                    renderInput={params => (
                                                                        <TextField
                                                                            {...params}
                                                                            label="Choose a country"
                                                                            variant="outlined"
                                                                            inputProps={{
                                                                                ...params.inputProps,
                                                                                autoComplete: 'new-password', // disable autocomplete and autofill
                                                                                form: {
                                                                                    autocomplete: 'off'
                                                                                }
                                                                            }}
                                                                        />
                                                                    )}
                                                                />
                                                            )}
                                                            <font style={{ fontSize: '13px', color: '#888' }}>Limit what countries this marketer can see in the Marketer platform. <u><b>Leave this field blank if you want to enable all countries.</b></u></font>


                                                        </div>

                                                    </div>

                                                    <div className="row">
                                                        <div className="col">
                                                            <p style={{ marginTop: 30 }}>Partners Visibility</p>
                                                            {!this.state.loadingMarketer &&  this.state.partners && this.state.partners.length > 0 && (
                                                            <Autocomplete
                                                                id="partners-select"
                                                                options={this.state.partners}
                                                                autoHighlight
                                                                multiple
                                                                limitTags={1}
                                                                disableCloseOnSelect
                                                                defaultValue={this.state.marketerPartnerSelected}
                                                                getOptionLabel={option => option.friendlyName}
                                                                onChange={(event, newValue) => {
                                                                    if (newValue) {
                                                                        console.log('partner change ', newValue)
                                                                        //let marketerPartnerSelected = newValue.map(el => el.partnerId)
                                                                        let marketerPartnerSelected = newValue
                                                                        this.setState({ marketerPartnerSelected: marketerPartnerSelected })
                                                                    }
                                                                }}
                                                                renderOption={(option, { selected }) => (
                                                                    <React.Fragment>
                                                                        <Checkbox
                                                                            color="primary"
                                                                            icon={icon}
                                                                            checkedIcon={checkedIcon}
                                                                            style={{ marginRight: 8 }}
                                                                            checked={selected}
                                                                        />
                                                                        {option.friendlyName}
                                                                    </React.Fragment>
                                                                )}
                                                                renderInput={params => (
                                                                    <TextField
                                                                        {...params}
                                                                        label="Choose a partner"
                                                                        variant="outlined"
                                                                        inputProps={{
                                                                            ...params.inputProps,
                                                                            autoComplete: 'new-password', // disable autocomplete and autofill
                                                                            form: {
                                                                                autocomplete: 'off'
                                                                            }
                                                                        }}
                                                                    />
                                                                )}
                                                            />
                                                            )}
                                                            <font style={{ fontSize: '13px', color: '#888' }}>Limit what partners this marketer can see in the Marketer platform. <u><b>Leave this field blank if you want to enable all partners.</b></u></font>


                                                        </div>

                                                    </div>


                                                </div>
                                            )}

                                            <br />
                                            <h3>Limits</h3>


                                            <div className="row">
                                                <div className="col">
                                                    <p style={{ marginTop: 30 }}>Max Audiences</p>
                                                    <input
                                                        type="number"
                                                        min="0.0"
                                                        className="form-control"
                                                        value={this.state.maxAudiences}
                                                        onChange={({ target }) => this.setState({ maxAudiences: target.value })}
                                                    />
                                                    <font style={{ fontSize: '13px', color: '#888' }}>Limit how many can create per account.</font>

                                                </div>
                                                <div className="col">
                                                    <p style={{ marginTop: 30 }}>Max Licenses</p>
                                                    <input
                                                        type="number"
                                                        min="0.0"
                                                        className="form-control"
                                                        value={this.state.maxLicenses}
                                                        onChange={({ target }) => this.setState({ maxLicenses: target.value })}
                                                    />
                                                    <font style={{ fontSize: '13px', color: '#888' }}>Limit how many can create per account.</font>

                                                </div>
                                                <div className="col">
                                                    <p style={{ marginTop: 30 }}>Max Daily Imports</p>
                                                    <input
                                                        type="number"
                                                        min="0.0"
                                                        className="form-control"
                                                        value={this.state.maxUploadsDaily}
                                                        onChange={({ target }) => this.setState({ maxUploadsDaily: target.value })}
                                                    />
                                                    <font style={{ fontSize: '13px', color: '#888' }}>Limit how many uploads per day.</font>


                                                </div>

                                            </div>




                                            <br />
                                            <h3>Other Options</h3>

                                            <div className="row">
                                                <div className="col">
                                                    <p style={{ marginTop: 30 }}>Partner Alias</p>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={this.state.partnerAlias}
                                                        onChange={({ target }) => this.setState({ partnerAlias: target.value })}
                                                    />
                                                    <font style={{ fontSize: '13px', color: '#888' }}>This alias is used in the creation of audiences names instead of the Partner's Friendly name.</font>

                                                </div>
                                                <div className="col">

                                                    <p style={{ marginTop: 30 }}>Pricing Type</p>
                                                    <select value={this.state.pricingType} className="form-control" onChange={event => this.setState({ pricingType: event.target.value })}>
                                                        <option key="revshare" value="revshare">
                                                            Revshare
                                                </option>
                                                        <option key="flat" value="flat">
                                                            Flat fee (Those partners doesn't have upload limits)
                                                </option>
                                                    </select>
                                                </div>
                                            </div>




                                            <div className="row">
                                                <div className="col">
                                                    <p style={{ marginTop: 30 }}>GDPR confirm</p>
                                                    <p style={{ 'margin': 0 }}>
                                                        <Bootstrap2Toggle
                                                            onClick={value => {
                                                                this.setState({ gdprConfirm: value })
                                                            }}
                                                            on={<span>ON</span>}
                                                            off={<span>OFF</span>}
                                                            size="xs"
                                                            offstyle="secondary"
                                                            active={this.state.gdprConfirm}
                                                        />
                                                    </p>
                                                    <font style={{ fontSize: '13px', color: '#888' }}>Toggle if the EU Partner has confirmed GDPR.</font>

                                                </div>
                                                <div className="col">

                                                    <p style={{ marginTop: 30 }}>Can Edit</p>
                                                    <p style={{ 'margin': 0 }}>
                                                        <Bootstrap2Toggle
                                                            onClick={value => {
                                                                this.setState({ canEdit: value })
                                                            }}
                                                            on={<span>ON</span>}
                                                            off={<span>OFF</span>}
                                                            size="xs"
                                                            offstyle="secondary"
                                                            active={this.state.canEdit}
                                                        />
                                                    </p>
                                                    <font style={{ fontSize: '13px', color: '#888' }}>Toggle if the Partner has editing cababilities in the UI.</font>

                                                </div>
                                                <div className="col">

                                                    <p style={{ marginTop: 30 }}>Can Create Sub-partners</p>
                                                    <p style={{ 'margin': 0 }}>
                                                        <Bootstrap2Toggle
                                                            onClick={value => {
                                                                console.log("bool ", value)
                                                                this.setState({ canCreateChildren: value })
                                                            }}
                                                            on={<span>ON</span>}
                                                            off={<span>OFF</span>}
                                                            size="xs"
                                                            offstyle="secondary"
                                                            active={this.state.canCreateChildren}
                                                        />
                                                    </p>
                                                    <font style={{ fontSize: '13px', color: '#888' }}>Toggle if the Partner can create sub partners under his account.</font>

                                                </div>

                                            </div>


                                            <div className="row">
                                                <div className="col">

                                                    <br />
                                                    <br />
                                                    <h3>Revenue shares</h3>


                                                    <BulkRevshareModal
                                                        showBulkRevhsareModal={this.state.showBulkRevhsareModal}
                                                        onCloseModal={() => this.setState({ showBulkRevhsareModal: false })}
                                                        reloadRevshares={() => this.loadRevShares()}
                                                        partner={this.props.location.state.partner}
                                                    />


                                                    <RevenueShareList
                                                        editMode={true}
                                                        hasNewRows={this.state.revshares && this.state.revshares.findIndex(it => it.new) != -1}
                                                        partners={this.state.subPartnerSettings}
                                                        dmps={this.state.dmpList}
                                                        dmpProducts={this.state.dmpProducts}
                                                        filter={this.state.revshareFilter}
                                                        onFilterChange={this.onRevshareFilterChange.bind(this)}
                                                        sort={this.state.revshareSort}
                                                        sortOrder={this.state.revshareSortOrder}
                                                        onchange={this.onRevenueShareChange.bind(this)}
                                                        onadd={this.onRevenueShareAdd.bind(this)}
                                                        onBulkCreate={this.onRevenueShareBulkCreate.bind(this)}
                                                        onSave={this.onRevenueShareSave.bind(this)}
                                                        onRemove={this.onRevenueShareRemove.bind(this)}
                                                        list={this.state.revshares}
                                                        offset={this.state.revshareOffset}
                                                        size={this.state.revshareSize}
                                                        onLoadMore={this.onRevenueShareLoadMore.bind(this)}

                                                    />
                                                </div>
                                            </div>







                                            <div className="new-segment-based-audience new-segment-based-audience--button-group">
                                                <BorderButton className="grey" label="Cancel" onClick={() => window.location.href = '/settings'} />
                                                <BorderButton disabled={this.state.disableButton} label="SAVE" onClick={this.onSubPartnersSave.bind(this)} />
                                                {this.state.saving && <Preloader transparent />}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </WhiteBox>
                        </div>
                    </div>

                </div>
            </PageWrapper>
        )
    }
}

export default connect(
    state => ({}),
    {
        goBack: () => push('/audiences')
    }
)(EditPartner)
